//import CryptoJS from 'crypto-js';
export class GlobalService{
    SECRET_KEY  = 'SFRC@raibeWEBAPP'
    CryptoJS = require("crypto-js");
    //appService = new AppService();

    setSessionStorageId(id, data){
        /*const ciphertext = this.encryptData(JSON.stringify(data));
        sessionStorage.setItem(id,ciphertext);*/
        sessionStorage.setItem(id,JSON.stringify(data))
    }

    getSessionStorageInObjectById(id){
        //return JSON.parse(this.decryptData(sessionStorage.getItem(id)));
        return JSON.parse(sessionStorage.getItem(id));
    }

    removeSessionStorageById(id){
        sessionStorage.removeItem(id);
    }

    setLocalStorageId(id, data){
        const ciphertext = this.encryptData(JSON.stringify(data));
        localStorage.setItem(id,ciphertext);
    }

    getLocalStorageInObjectById(id){
        return JSON.parse(this.decryptData(localStorage.getItem(id)));
    }

    removeLocalStorageById(id){
      localStorage.removeItem(id);
    }

    

    encryptData(data) {
        var ciphertext = this.CryptoJS.AES.encrypt(data, this.SECRET_KEY).toString();
        return ciphertext;
     }
  
     decryptData(data) {
        var decryptedData = this.CryptoJS.AES.decrypt(data.toString(), this.SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
        return decryptedData;
  
     }

     
     /*isDevicePC(device){
        if(device.mobile || device.android || device.ipad || device.androidPhone || device.iPhoneXR  || device.iPhoneXSMax  || device.ios  || device.ipad  || device.iphone  || device.iphoneX || device.ipod || device.dingding ){
            return false
        }else{
            return true;
        }
     }*/

     isDevicePC(device){
        if(device.mobile || device.android || device.ipad || device.androidPhone || device.iPhoneXR  || device.iPhoneXSMax  || device.ios  || device.ipad  || device.iphone  || device.iphoneX || device.ipod || device.dingding ){
            return false;
        }else{
            const  userAgent= window.navigator.userAgent;
            const  navplatform= window.navigator.platform;
            const maxTouchPoints= navigator.maxTouchPoints;
            if (/android/i.test(userAgent)) {
                return false;
              }
              else if ((/iPad|iPhone|iPod/.test(userAgent))|| (navplatform === 'MacIntel' && maxTouchPoints > 1)){
                return false;
              }else
                return true;
            
        }
        
     }

     

     getUser(){
         if(sessionStorage.getItem('user')){
            return this.getSessionStorageInObjectById('user');
         }else
            return null;
     }

     setUser(user){
         this.setSessionStorageId('user',user);
     }

     getSessionSouscription(){
        if(sessionStorage.getItem('souscription')){
            return this.getSessionStorageInObjectById('souscription');
         }else
            return null;
     }

     setSessionSouscription(id,value){
        var sessionSouscription = this.getSessionSouscription();
        if(sessionSouscription!= null){
            sessionSouscription[id] = value;
            //insertion en sessionStorage
            this.setSessionStorageId('souscription',sessionSouscription);
            return this.getSessionSouscription();
        }else{
            let sessionSouscription = {}
            sessionSouscription[id] = value;
            //insertion en sessionStorage
            this.setSessionStorageId('souscription',sessionSouscription);
            return this.getSessionSouscription();
        }
        
     }

     removeIdInSessionSouscription(id){
        var sessionSouscription = this.getSessionSouscription();
        if(sessionSouscription!= null){
            delete sessionSouscription[id];
           
            //insertion en sessionStorage
            this.setSessionStorageId('souscription',sessionSouscription);
        }
        
     }

     rechargeSessionSouscription(value){
        this.setSessionStorageId('souscription',value);
        return this.getSessionSouscription();
     }

     getUUID(UUID){
         if(localStorage.getItem('uuid')){
             return localStorage.getItem('uuid');
         }else{
             const uuid = UUID.v1();
             localStorage.setItem('uuid',uuid);
             return uuid;
         }
     }

     formatDateMysqlToPhp(curdate) {
      if(curdate) {
        return curdate.substr(8,2)+'/'+curdate.substr(5,2)+'/'+curdate.substr(0,4);
      } else return '-';
     }

}